/** Redux action constants */
export const SET_TRIALTAG = 'SET_TRIALTAG';

/** Model Types */
export interface TrialTag {
  id: number;
  name: string;
  description: string;
  tagId: number;
}
export interface TrialTagMapping {
  id: number;
  trialId: number;
  tagId: number;
}

export interface TrialTagById {
  [key: number]: TrialTag;
}

export interface TrialTagState {
  byId?: TrialTagById;
  allIds?: number[]
}

type setTrialTag = {
  type: typeof SET_TRIALTAG;
  payload: TrialTag[];
}

export type TrialTagActionTypes = setTrialTag;
